import { StructError } from "superstruct"
import type { FetchError } from "./FetchError"
import { isFetchError } from "./isFetchError"

export const isValidationError = (error: unknown): error is FetchError => {
  return isFetchError(error) && error.cause instanceof StructError
}
